import { z } from 'zod'

export const STRATALYST_REPORT_UPLOAD_OPERATIONS_CONTRACT_VERSION = '1.0.0' as const
export const stratalystReportUploadOperationsResponseSchema = z.unknown()
export type StratalystReportUploadOperationsResponse = z.infer<typeof stratalystReportUploadOperationsResponseSchema>
